<template>
  <page>
    <div>
      <v-card>
        <form>
          <v-container fluid grid-list-sm>
            <v-layout row wrap>
              <v-flex xs12>
                <v-expansion-panels v-model="panel1" multiple>
                  <v-expansion-panel>
                    <v-expansion-panel-header>
                      <div><v-icon>mdi-filter-variant</v-icon> Selection Criteria</div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-card>
                        <v-card-text>
                          <v-container fluid grid-list-lg>
                            <v-layout row wrap>
                              <v-flex xs12 md4 lg6>
                                <cal-picker
                                  v-model="form.entryDateFrom"
                                  :label="label.entryDateFrom"
                                  :data-vv-as="label.entryDateFrom"
                                  data-vv-name="form.entryDateFrom"
                                  :error-messages="errors.collect('form.entryDateFrom')"
                                  v-validate="'required|start_after_today'"
                                ></cal-picker>
                              </v-flex>
                              <v-flex xs12 md4 lg6>
                                <cal-picker
                                  v-model="form.entryDateTo"
                                  :label="label.entryDateTo"
                                  :data-vv-as="label.entryDateTo"
                                  data-vv-name="form.entryDateTo"
                                  :error-messages="errors.collect('form.entryDateTo')"
                                  v-validate="toDateValidation(form.entryDateFrom)"
                                ></cal-picker>
                              </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                              <v-flex xs12 md4 lg6>
                                <v-autocomplete
                                  :label="label.viewType"
                                  :items="custLogTypeViewList"
                                  v-model="form.viewType"
                                  item-text="label"
                                  item-value="value"
                                  data-vv-name="form.viewType"
                                  :data-vv-as="label.viewType"
                                  :error-messages="errors.collect('form.viewType')"
                                ></v-autocomplete>
                              </v-flex>
                            </v-layout>
                          </v-container>
                        </v-card-text>
                      </v-card>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
                <v-expansion-panels v-model="panel2" multiple>
                  <v-expansion-panel>
                    <v-expansion-panel-header>
                      <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-card>
                        <v-card-text>
                          <v-container fluid grid-list-lg>
                            <v-layout row wrap>
                              <v-flex xs12 lg4>
                                <v-autocomplete
                                  :label="label.logTypeOpt"
                                  :items="custLogTypeOptList"
                                  v-model="filters.logTypeOpt"
                                  item-text="label"
                                  item-value="value"
                                  data-vv-name="filters.logTypeOpt"
                                  :data-vv-as="label.logTypeOpt"
                                  :error-messages="errors.collect('filters.logTypeOpt')"
                                  @change="doLogTypeFilters"
                                ></v-autocomplete>
                              </v-flex>
                              <v-flex v-if="filters.logTypeOpt === 'S'" xs12 lg8>
                                <v-autocomplete
                                  multiple
                                  :label="label.sLogTypeOpt"
                                  :items="sCustLogTypeOptList"
                                  v-model="filters.sLogTypeOpt"
                                  item-text="label"
                                  item-value="value"
                                  data-vv-name="form.sLogTypeOpt"
                                  :data-vv-as="label.sLogTypeOpt"
                                  :error-messages="errors.collect('form.sLogTypeOpt')"
                                  @change="doCheckFilters"
                                ></v-autocomplete>
                              </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                              <v-flex xs12 lg4>
                                <v-autocomplete
                                  :label="label.cPolTypeOpt"
                                  :items="cPolTypeOptList"
                                  v-model="filters.cPolTypeOpt"
                                  item-text="label"
                                  item-value="value"
                                  data-vv-name="filters.cPolTypeOpt"
                                  :data-vv-as="label.cPolTypeOpt"
                                  :error-messages="errors.collect('filters.cPolTypeOpt')"
                                  @change="doPolTypeFilters"
                                ></v-autocomplete>
                              </v-flex>
                              <v-flex v-if="filters.cPolTypeOpt === 'S'" xs12 lg8>
                                <v-autocomplete
                                  multiple
                                  :label="label.sPolTypeOpt"
                                  :items="sPolTypeOptList"
                                  v-model="filters.sPolTypeOpt"
                                  item-text="label"
                                  item-value="value"
                                  data-vv-name="form.sPolTypeOpt"
                                  :data-vv-as="label.sPolTypeOpt"
                                  :error-messages="errors.collect('form.sPolTypeOpt')"
                                  @change="doCheckFilters"
                                ></v-autocomplete>
                              </v-flex>
                            </v-layout>
                          </v-container>
                        </v-card-text>
                      </v-card>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-flex>
            </v-layout>
          </v-container>
          <v-btn color="primary" type="submit" :loading="loading" @click.prevent="doExport">
            <v-icon left dark>mdi-file-export</v-icon>
            {{ label.export }}
          </v-btn>
          <v-btn-toggle dense mandatory v-model="form.format">
            <v-btn text v-for="format in supportedList" :key="format.value" :value="format.value">
              <span>{{ format.label }}</span>
              <v-icon :color="format.color">{{ format.icon }}</v-icon>
            </v-btn>
          </v-btn-toggle>
        </form>
      </v-card>
    </div>
  </page>
</template>

<script>
import { extractMenu } from '@/utils/extract'
import { reportFormat } from '@/const/report'
import MessageMixin from '@/mixins/message'
import { custLogTypeView, custLogTypeOpt, cPolTypeOpt } from '@/const/underwriting'
import { expandURI, filterQuery } from '@/utils/ajax'
import { removeTime } from '@/utils/date'
import isAfter from 'date-fns/isAfter'

export default {
  data() {
    return {
      form: {
        entryDateFrom: null,
        entryDateTo: null,
        format: undefined,
        viewType: 'ALL',
        sLogTypeOpt: '',
        sPolTypeOpt: ''
      },
      label: {
        entryDateFrom: 'From Entry Date',
        entryDateTo: 'To Entry Date',
        format: 'Export Format',
        export: 'Export to',
        viewType: 'Customer Log From',
        logTypeOpt: 'Log Type(s)',
        cPolTypeOpt: 'Policy Type(s)',
        sLogTypeOpt: 'Selected Log Type(s)',
        sPolTypeOpt: 'Selected Policy Type(s)'
      },
      showClmHelpList: false,
      showPolicyHelpList: false,
      menu: {},
      supportedFormat: [],
      loading: false,
      validatePolNo: '',
      validateClmNo: '',
      filters: {
        logTypeOpt: 'A',
        cPolTypeOpt: 'A',
        sLogTypeOpt: [],
        sPolTypeOpt: []
      },
      sCustLogTypeOptList: [],
      sPolTypeOptList: [],
      panel1: [0],
      panel2: []
    }
  },
  methods: {
    async doInit() {
      try {
        if (this.$store.state.reports.specialReports.init !== 1) {
          await this.$store.dispatch('specialReportsInit')
        }
        const apiURI = this.specialMenu.customerLogStatistics
        const result = await this.$http.get(apiURI)
        if (result.data) {
          const { data } = result.data
          if (data) {
            this.supportedFormat = data.format
            this.menu = extractMenu(result.data._links)
          }
        }
        this.getLogTypeList()
        this.getPolTypeList()
      } catch (err) {
        throw err
      }
    },
    async pushLogTypeFilter() {
      this.filters.sLogTypeOpt = []
      this.sCustLogTypeOptList.map((data) => {
        this.filters.sLogTypeOpt.push(data.value)
      })
    },
    async pushPolTypeFilter() {
      this.filters.sPolTypeOpt = []
      this.sPolTypeOptList.map((data) => {
        this.filters.sPolTypeOpt.push(data.value)
      })
    },
    doExport() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.processExport()
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async processExport() {
      this.form.sLogTypeOpt = ''
      this.form.sPolTypeOpt = ''
      for (let i in this.filters.sLogTypeOpt) {
        this.form.sLogTypeOpt += this.filters.sLogTypeOpt[i] + ','
      }
      this.form.sLogTypeOpt = this.form.sLogTypeOpt.slice(0, -1)

      for (let j in this.filters.sPolTypeOpt) {
        this.form.sPolTypeOpt += this.filters.sPolTypeOpt[j] + ','
      }
      this.form.sPolTypeOpt = this.form.sPolTypeOpt.slice(0, -1)
      const apiURI = this.menu.export
      if (apiURI) {
        try {
          this.submitting = true
          await this.$http.post(apiURI, this.form)
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    doLogTypeFilters() {
      if (this.filters.logTypeOpt === 'S') {
        this.filters.sLogTypeOpt = []
      } else {
        this.pushLogTypeFilter()
      }
    },
    doPolTypeFilters() {
      if (this.filters.cPolTypeOpt === 'S') {
        this.filters.sPolTypeOpt = []
      } else {
        this.pushPolTypeFilter()
      }
    },
    async getLogTypeList() {
      const apiURI = this.menu.logTypeList
      if (apiURI) {
        try {
          const expand = {
            manageType: ''
          }
          const result = await this.$http.get(filterQuery(expandURI(apiURI, expand)))
          const data = result.data.data
          this.sCustLogTypeOptList = []
          if (data) {
            for (let i in data) {
              this.sCustLogTypeOptList.push({ value: data[i].value, label: data[i].label })
            }
            this.pushLogTypeFilter()
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async getPolTypeList() {
      const apiURI = this.menu.polTypeList
      if (apiURI) {
        try {
          const result = await this.$http.get(apiURI)
          const data = result.data.data
          this.sPolTypeOptList = []
          if (data) {
            for (let i in data) {
              this.sPolTypeOptList.push({ value: data[i].value, label: data[i].label })
            }
            this.pushPolTypeFilter()
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async doCheckFilters() {
      if (this.filters.sLogTypeOpt.length === 0) {
        this.filters.logTypeOpt = 'A'
        this.pushLogTypeFilter()
      }
      if (this.filters.sPolTypeOpt.length === 0) {
        this.filters.cPolTypeOpt = 'A'
        this.pushPolTypeFilter()
      }
    },
    toDateValidation(entryDateFrom) {
      const result = 'required|from_to_date:' + entryDateFrom
      return result
    }
  },
  computed: {
    specialMenu() {
      return this.$store.state.reports.specialReports.menu
    },
    supportedList() {
      const result = []
      if (this.supportedFormat && this.supportedFormat.length > 0) {
        this.supportedFormat.map((format) => {
          if (reportFormat[format]) {
            result.push(reportFormat[format])
          }
        })
      }
      return result
    },
    custLogTypeViewList() {
      let result = []
      Object.keys(custLogTypeView).forEach(function (key) {
        const viewType = custLogTypeView[key]
        result.push({
          value: key,
          label: viewType
        })
      })
      return result
    },
    custLogTypeOptList() {
      let result = []
      Object.keys(custLogTypeOpt).forEach(function (key) {
        const logType = custLogTypeOpt[key]
        result.push({
          value: key,
          label: logType
        })
      })
      return result
    },
    cPolTypeOptList() {
      let result = []
      Object.keys(cPolTypeOpt).forEach(function (key) {
        const polType = cPolTypeOpt[key]
        result.push({
          value: key,
          label: polType
        })
      })
      return result
    }
  },
  created() {
    this.doInit()

    this.$validator.extend('start_after_today', {
      getMessage(field, args) {
        return 'Entry Date To must be equal or greater than Entry Date From'
      },
      validate(value, args) {
        if (value) {
          const today = removeTime(new Date())
          const tomorrow = new Date(today)
          tomorrow.setDate(tomorrow.getDate() + 1)
          const startDate = removeTime(value)
          return isAfter(tomorrow, startDate)
        } else return true
      }
    })
  },
  watch: {},
  mixins: [MessageMixin]
}
</script>
